module.exports = __webpack_public_path__ + "vue/img/main_logo.3c2e7401.svg";